"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var document_merge_service_1 = require("./document-merge.service");
var material_1 = require("@angular/material");
var ng2_dragula_1 = require("ng2-dragula");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var static_method_1 = require("../../../shared/utils/static-method");
var dialog_config_helper_1 = require("../../../shared/utils/dialog-config-helper");
var confirm_dialog_component_1 = require("../../../shared/dialogs/confirm/confirm-dialog.component");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var Subject_1 = require("rxjs/Subject");
var icon_info_provider_service_1 = require("../../../shared/services/impl/icon-info-provider.service");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var zip_1 = require("rxjs/observable/zip");
var merge_operation_dto_1 = require("./model/merge-operation-dto");
var DocumentMergeComponent = /** @class */ (function () {
    function DocumentMergeComponent(documentMergeService, dragulaService, exportTemplateService, changeDetectorRefs, currentLanguageProvider, dialogRef, dialog, exportDataLoaderService, data) {
        this.documentMergeService = documentMergeService;
        this.dragulaService = dragulaService;
        this.exportTemplateService = exportTemplateService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.currentLanguageProvider = currentLanguageProvider;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.exportDataLoaderService = exportDataLoaderService;
        this.data = data;
        this.dataSource = null;
        this.coverData = null;
        this.dataDragula = [];
        this.pageOptions = [];
        this.coverTemplates = [];
        this.isNameValid = true;
        this.isPaginationPositionValid = true;
        this.documentTableDisplayColumnNames = ['dragIcon', 'name', 'fileFormat', 'pagingCount', 'action'];
        this.dragOptions = {
            invalid: function (el) { return el.classList.contains('no-drag'); }
        };
        this._destroy$ = new Subject_1.Subject();
        this.dataForMerging = data.dataForMerging;
        this.pageOptions.push({ name: 'page_option_top_right', id: 1 });
        this.pageOptions.push({ name: 'page_option_top_left', id: 2 });
        this.pageOptions.push({ name: 'page_option_top_center', id: 3 });
    }
    DocumentMergeComponent_1 = DocumentMergeComponent;
    DocumentMergeComponent.constructMergeOperationDto = function (documentInfos, languageId, coverLayoutName, coverCustomData, formProperties) {
        var mergeOperationDto = new merge_operation_dto_1.MergeOperationDto();
        mergeOperationDto.mergeDocumentInfos = documentInfos;
        mergeOperationDto.coverCustomData = coverCustomData;
        mergeOperationDto.coverLayoutName = coverLayoutName;
        mergeOperationDto.formId = formProperties ? formProperties.viewFormId : null;
        mergeOperationDto.formName = formProperties ? formProperties.viewFormName : null;
        mergeOperationDto.languageId = languageId;
        return mergeOperationDto;
    };
    DocumentMergeComponent.getConfig = function (data) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '820px';
        dialogConfig.height = 'auto';
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            dataForMerging: data
        };
        return dialogConfig;
    };
    DocumentMergeComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
        if (this.dragulaService) {
            this.dragulaService.destroy('merge-documents');
        }
    };
    DocumentMergeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataForMerging.documentPaginationPosition = this.pageOptions[0]['id'];
        this.dataForMerging.documentsToMerge = this.dataForMerging.documentsToMerge.map(function (doc) {
            doc.iconInfo = icon_info_provider_service_1.IconInfoProviderService.getFileIconInfo(doc.extension);
            return doc;
        });
        this.pdfDocumentIconInfo = icon_info_provider_service_1.IconInfoProviderService.getFileIconInfo('pdf');
        this.dataSource = new material_1.MatTableDataSource(this.dataForMerging.documentsToMerge);
        this.coverData = this.dataForMerging.coverDisplayInfo
            && new material_1.MatTableDataSource([this.dataForMerging.coverDisplayInfo]);
        this.dataDragula = this.dataForMerging.documentsToMerge;
        this.dragulaService.drop
            .pipe(operators_1.filter(function (value) {
            return value[0] === 'merge-documents';
        }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (args) { return _this.onDrag(); });
        this.currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) { return language.getId(); }), operators_1.publishReplay(1), operators_1.refCount());
        // load cover page generation templates
        this.currentLanguageId$
            .pipe(operators_1.switchMap(function (languageId) { return _this.exportTemplateService.loadTemplatesDataByCategoryName(_this.dataForMerging.categoryId, languageId); }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (templatesData) {
            _this.coverTemplates = templatesData;
        });
    };
    DocumentMergeComponent.prototype.onRemove = function (row) {
        var _this = this;
        var dialogConfig = dialog_config_helper_1.DialogConfigHelper.getConfirmationDialogConfig('ejustice_merge_document_confirm_delete_title', 'ejustice_merge_document_confirm_delete_body');
        this.dialog.open(confirm_dialog_component_1.ConfirmDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (confirmed) {
            if (confirmed) {
                var index = _this.dataForMerging.documentsToMerge.findIndex(function (item) { return item['documentId'] === row['documentId']; });
                if (index > -1) {
                    _this.dataForMerging.documentsToMerge.splice(index, 1);
                }
                _this.dataDragula = _this.dataForMerging.documentsToMerge;
                _this.dataSource = new material_1.MatTableDataSource(_this.dataForMerging.documentsToMerge);
                _this.changeDetectorRefs.detectChanges();
            }
        });
    };
    DocumentMergeComponent.prototype.onCancel = function (returnDialogData) {
        if (returnDialogData === void 0) { returnDialogData = false; }
        this.dialogRef.close(returnDialogData ? this.dataForMerging : undefined);
    };
    DocumentMergeComponent.prototype.onMerge = function () {
        var _this = this;
        if (this.validate()) {
            var categoryId_1 = this.dataForMerging.categoryId;
            var entityId_1 = this.dataForMerging.entityId;
            var subEntityFieldName_1 = this.dataForMerging.subEntityFieldName;
            var pagingPosition_1 = this.dataForMerging.documentPaginationPosition;
            var documentInfos_1 = this.dataForMerging.documentsToMerge;
            var coverLayoutName_1 = this.dataForMerging.coverTemplateData.layoutName;
            var coverCustomData$ = coverLayoutName_1 ? this.getDataForCoverTemplate() : Observable_1.Observable.of({});
            var formProperties$ = coverLayoutName_1 ? this.dataForMerging.coverTemplateData.formProperties$ : Observable_1.Observable.of(void 0);
            zip_1.zip(this.currentLanguageId$, coverCustomData$, formProperties$)
                .pipe(operators_1.switchMap(function (_a) {
                var languageId = _a[0], coverCustomData = _a[1], formProperties = _a[2];
                var mergeOperationDto = DocumentMergeComponent_1.constructMergeOperationDto(documentInfos_1, languageId, coverLayoutName_1, coverCustomData, formProperties);
                return _this.documentMergeService.mergeDocument(categoryId_1, entityId_1, subEntityFieldName_1, mergeOperationDto, pagingPosition_1);
            }), operators_1.takeUntil(this._destroy$))
                .subscribe(function (response) {
                static_method_1.saveByteArray(_this.dataForMerging.mergedDocumentName, response);
            });
        }
    };
    DocumentMergeComponent.prototype.onMergeDocumentNameChange = function (name) {
        this.dataForMerging.mergedDocumentName = name;
        !this.isNameValid ? this.isNameValid = !!this.dataForMerging.mergedDocumentName : this.isNameValid = true;
    };
    DocumentMergeComponent.prototype.onDocumentPageOptionChange = function (pageOption) {
        this.dataForMerging.documentPaginationPosition = pageOption;
        !this.isPaginationPositionValid ? this.isPaginationPositionValid = !!this.dataForMerging.documentPaginationPosition : this.isPaginationPositionValid = true;
    };
    DocumentMergeComponent.prototype.onCoverTemplateChange = function (templateId) {
        this.dataForMerging.coverTemplateData.layoutName = templateId;
        if (templateId) {
            var categoryTemplateViewModel = this.coverTemplates.find(function (template) { return template.id === templateId; });
            var coverDisplayInfo = {
                title: categoryTemplateViewModel.name,
                size: 'Unknown',
                iconInfo: this.pdfDocumentIconInfo
            };
            this.dataForMerging.coverDisplayInfo = coverDisplayInfo;
            this.coverData = new material_1.MatTableDataSource([coverDisplayInfo]);
        }
        else {
            this.coverData = null;
        }
    };
    DocumentMergeComponent.prototype.getDataForCoverTemplate = function () {
        if (this.exportDataLoaderService) {
            return this.exportDataLoaderService.getExportData(this.dataForMerging.categoryId, this.dataForMerging.entityId);
        }
        return Observable_1.Observable.of({});
    };
    DocumentMergeComponent.prototype.validate = function () {
        var isNameContainsDot = this.dataForMerging.mergedDocumentName && this.dataForMerging.mergedDocumentName.includes('.');
        this.nameValidationKey = isNameContainsDot ? 'ejustice_document_ui.labels.field-must-not-contain-dot' : 'ng-controls_ui.labels.field-is-required';
        this.isNameValid = this.dataForMerging.mergedDocumentName && !isNameContainsDot;
        this.isPaginationPositionValid = !!this.dataForMerging.documentPaginationPosition;
        return this.isNameValid && this.isPaginationPositionValid;
    };
    DocumentMergeComponent.prototype.onDrag = function () {
        var _this = this;
        this.changeDetectorRefs.detectChanges();
        this.dataForMerging.documentsToMerge.sort(function (a, b) {
            return _this.dataDragula.findIndex(function (item) { return item && item['documentId'] === a['documentId']; }) -
                _this.dataDragula.findIndex(function (item) { return item && item['documentId'] === b['documentId']; });
        });
    };
    var DocumentMergeComponent_1;
    DocumentMergeComponent = DocumentMergeComponent_1 = __decorate([
        core_1.Component({
            selector: 'ejustice-document-merge',
            styles: [require('./document-merge.component.css')],
            template: require('./document-merge.component.html')
        }),
        __param(7, core_1.Optional()),
        __param(8, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [document_merge_service_1.DocumentMergeService,
            ng2_dragula_1.DragulaService,
            idm_export_templates_service_client_js_1.ExportTemplatesService,
            core_1.ChangeDetectorRef,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            material_1.MatDialogRef,
            material_1.MatDialog,
            idm_dynamic_forms_controls_1.ExportDataLoaderService, Object])
    ], DocumentMergeComponent);
    return DocumentMergeComponent;
}());
exports.DocumentMergeComponent = DocumentMergeComponent;
//# sourceMappingURL=document-merge.component.js.map